export const CLIENT_LINK = "https://www.latviesi.com";

export const defaultLimit = 12;

export default CLIENT_LINK;
